import { Dialog, DialogTitle } from "@mui/material";
import { CreateBase, useRefresh } from "react-admin";
import { useNavigate } from "react-router";
import { DialogCloseButton } from "../../misc/DialogCloseButton";
import type { Employee } from "../../providers/employeesProvider";
import { CreateEmployeeForm } from "./CreateEmployeeForm";
import type { DialogProps } from "../../misc/DialogProps";
import { useCurrentDrivingSchoolId } from "../../hooks/useCurrentDrivingSchoolId";

function isInstructorEmployee(employee: Employee): boolean {
  return employee.roles.includes("instructor");
}

export function CreateEmployeeDialog(props: DialogProps) {
  const { onClose } = props;
  const drivingSchoolId = useCurrentDrivingSchoolId();
  const navigate = useNavigate();
  const refresh = useRefresh();

  const createProps = {
    resource: "employees",
    mutationOptions: {
      onSuccess: (createdEmployee: Employee) => {
        refresh();
        onClose();
        if (isInstructorEmployee(createdEmployee)) {
          showSuccessToast("Fahrlehrer erfolgreich erstellt.");
          navigate(`/drivingSchools/${drivingSchoolId}/employees#instructors`);
        } else {
          showSuccessToast("Büro-Mitarbeiter erfolgreich erstellt.");
          navigate(`/drivingSchools/${drivingSchoolId}/employees#office`);
        }
      },
      onError: (error: Error) => {
        handleError("Fehler beim Erstellen des Mitarbeiters.", error);
      },
    },
    transform: (data: any) => ({ ...data, drivingSchoolId }),
  };

  return (
    <Dialog {...props} maxWidth="sm" fullWidth>
      <DialogTitle>Neuer Mitarbeiter</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <CreateBase {...createProps}>
        <CreateEmployeeForm />
      </CreateBase>
    </Dialog>
  );
}
